import { render } from "./ConfirmacaoEmail.vue?vue&type=template&id=24140fa9"
import script from "./ConfirmacaoEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoEmail.vue?vue&type=script&lang=js"

import "./ConfirmacaoEmail.vue?vue&type=style&index=0&id=24140fa9&lang=css"

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__